import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FacebookFilledSvg from "@ant-design/icons-svg/es/asn/FacebookFilled";
import AntdIcon from "../components/AntdIcon";
var FacebookFilled = function FacebookFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FacebookFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FacebookFilled.displayName = 'FacebookFilled';
}
export default /*#__PURE__*/React.forwardRef(FacebookFilled);